import React, { PropTypes } from 'react';

import {
  button as defaultStyle,
  primary as primaryStyle,
} from './styles.module.css';

/**
 * Generic button presentational component.
 */
const Button = ({ children, className, disabled, primary, ...props }) => (
  <button
    type="button"
    className={[primary ? primaryStyle : defaultStyle, className].join(' ')}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
);

Button.propTypes = {
  /**
   * Children contents of button.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to disabled button.
   */
  disabled: PropTypes.bool,
  /**
   * Boolean to style button as primary.
   */
  primary: PropTypes.bool,
};

Button.defaultProps = {
  className: undefined,
  disabled: false,
  primary: false,
};

export default Button;



// WEBPACK FOOTER //
// ./app/src/components/Button/index.jsx